import { createSelector } from 'reselect'
import studentSlideTimerSelector from 'redux/selectors/student/timer'

import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.TIMER_MATCHING_PAIRS,
])

const getStudentViewData = state => state.student
const getSlideId = (state, props) => props.session.session_uid + '_' + props.slide.slideId

const getStudentSlideData = createSelector(
	[ getStudentViewData, studentSlideTimerSelector, getSlideId, featureFlagsSelector ],
	(student, timer, slideId, featureFlags) => {
		const slide_data = student.slides[slideId]

		let isImmersiveReaderEnabled = false

		if (slide_data) {
			isImmersiveReaderEnabled = slide_data.shouldShowImmersiveReader
		}

		return {
			slide_data,
			timer: featureFlags[featureFlagsTypes.TIMER_MATCHING_PAIRS]
				? timer : null,
			shouldShowImmersiveReader: isImmersiveReaderEnabled,
		}
	}
)

export default getStudentSlideData
